import React, { useState } from 'react';
import { View } from 'react-native';
import { useActiveAnnouncements } from '../../hooks/useAnnouncements';
import { useAuth } from '../../hooks/useAuth';
import AnnouncementBanner from './AnnouncementBanner';

const SystemAnnouncementBanner: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const { data: announcements = [], isLoading } = useActiveAnnouncements({
    enabled: isAuthenticated,
  });
  const [dismissedIds, setDismissedIds] = useState<Set<number>>(new Set());

  // Get the first active announcement that hasn't been dismissed
  const activeAnnouncement = announcements.find(
    (ann) => !dismissedIds.has(ann.id)
  );

  if (isLoading || !activeAnnouncement) {
    return null;
  }

  const handleDismiss = () => {
    setDismissedIds((prev) => new Set(prev).add(activeAnnouncement.id));
  };

  return (
    <View style={{ width: '100%' }}>
      <AnnouncementBanner
        announcement={activeAnnouncement}
        onDismiss={handleDismiss}
      />
    </View>
  );
};

export default SystemAnnouncementBanner;
